import React from 'react';

const JobFilter = () => {
    return (
        <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
            <h4 className="mb-0 ct_fs_20  mb-4">Content</h4>
            <div className="ct_filter_btn ">
                <button className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2">
                    Filter
                    <img src="../assets/img/octicon_filter-16.png" alt="" />
                </button>
            </div>
            <div className="ct_filter_sidebar ct_custom_scroll">
                <div className="ct_close_filter d-block d-lg-none">
                    <i className="fa-solid fa-xmark"></i>
                </div>
                <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3 ">Category</h5>
                    <ul>
                        <li>
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Marketing
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Product
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Sales
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Operations
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Engineering
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Personal
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3 ">Location</h5>
                    <ul>
                        <li>
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Toronto, Canada
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Newyork, USA
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Lead, York
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3 ">Job Type</h5>
                    <ul>
                        <li>
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Full-Time
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Part-Time
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Remote
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Hybrid
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
};

export default JobFilter;